import React from 'react'

function privacy() {
  return (
    <div>
        <div className="uk-section bg-primary">
            <div className="uk-container">
                <h1 className='text-primary uk-text-capitalize uk-text-center'>
                    privacy policy
                </h1>
                <div>
                    <h3 className='text-primary uk-text-capitalize uk-text-left'>
                        privacy policy updates
                    </h3>
                    <p className='text-secondary uk-text-left'>
                        Our Privacy Policy undergoes periodic updates to align with changes in our practices or for legal, operational, or regulatory reasons. Whenever revisions occur, we will post them on the Site, accompanied by an updated “Last updated” 1st July 2024. It is your responsibility to review this policy periodically to stay informed about any modifications.
                    </p>
                    <p className='text-secondary uk-text-left'>
                        Collection and Usage of Personal Information In order to provide our services effectively, we collect personal data from various sources. The specific types of information we gather and their usage may vary based on your interactions with us. Beyond the specified purposes, we utilize this collected information for communication, service delivery, legal compliance, enforcement of terms, and protection of the Company’s rights and those of our users.
                    </p>
                    <p className='text-secondary uk-text-left'>
                        Categories of Personal Information The personal information we acquire depends on your engagement with our Site and utilization of our services. When we refer to “personal information,” we encompass data that identifies, relates to, describes, or can be linked to you. The following sections outline the specific categories and types of personal information we collect.
                    </p>
                </div>
            </div>
        </div>
        <div className="uk-section">
            <div className="uk-container">
                <h1 className='text-primary uk-text-capitalize uk-text-center'>
                    data privacy
                </h1>
               <div className="uk-text-left">
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        data usage:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        The data we collect is used to provide and improve our services, process transactions, and communicate with you.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        data sharing:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        We do not sell or rent your personal data to third parties. However, we may share your information with trusted partners who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        data storage:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        Your information is stored on secure servers and is only accessible by a limited number of persons who have special access rights to such systems.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        data protection:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        We implement a variety of security measures to maintain the safety of your personal information. However, please note that we cannot be held liable for any mishaps resulting from the negligence of third parties.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        website security:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        Our website is equipped with advanced encryption protocols to protect your data during transmission. We regularly update and patch our systems to mitigate potential vulnerabilities and ensure robust defense against cyber threats.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        content protection:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        All content hosted on our website is subject to rigorous scrutiny and monitoring to prevent unauthorized access, modification, or distribution. We implement access controls and authentication mechanisms to safeguard sensitive information from unauthorized disclosure.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        data minimization:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        We collect and retain only the information necessary to fulfil the purposes outlined in our Privacy Policy. We adhere to principles of data minimization to reduce the risk of data breaches and unauthorized access.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        user consent:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        Prior to collecting any personal information, we obtain explicit consent from users and provide clear disclosure about the purposes for which their data will be used. Users have the right to withdraw their consent at any time, and we respect their preferences regarding data processing.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        third-party compliance:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        We carefully vet and select third-party service providers to ensure they adhere to stringent data protection standards. Any third parties entrusted with processing personal data on our behalf are contractually obligated to implement adequate security measures and comply with relevant data protection regulations.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        incident response:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        In the event of a data breach or security incident, we have established protocols and procedures to promptly detect, assess, and mitigate the impact on affected individuals. We notify relevant authorities and stakeholders in accordance with legal requirements and take necessary steps to prevent future occurrences.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        continuous improvement:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        Our commitment to data protection extends beyond compliance with existing regulations. We regularly review and enhance our security practices, leveraging industry best practices and emerging technologies to adapt to evolving threats and ensure the ongoing confidentiality and integrity of your information.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        data retention:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        We will retain your personal information for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        data rights:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        Users do not have the right to delete their personal data. Users must update their personal information with the latest updates if there are any changes in KYC.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        record keeping:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        All communications relevant to service provision and transactions will be recorded and stored securely in compliance with legal and regulatory requirements.
                    </p>
                    <h3 className='uk-text-capitalize text-primary uk-margin-remove'>
                        data collection:
                    </h3>
                    <p className='text-secondary uk-margin-small uk-text-justify'>
                        We collect personal information that you provide to us voluntarily. This may include your name, contact information, and payment details like below
                    </p>
                    <div className='uk-margin-left'>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>Name:</span> The individual’s given name.
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>Address:</span> Residential or business address.
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>Phone Number:</span>  Contact number for communication.
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>Mailing Address:</span> Specific address for correspondence.
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>ZIP Code:</span> Postal code for location identification.
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>Email Address:</span> Electronic communication identifier.
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>ID Numbers:</span> 
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>Social Security Numbers (SSNs):</span> Unique identifiers issued by government agencies. Customer IDs: Identification numbers assigned by businesses.
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>Other ID Numbers:</span>  Various identification codes used for individual recognition. Account Information:
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>Username:</span> User-specific login name if any.
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>Password:</span> Secure access credential if any.
                        </p>
                        <p className='text-secondary uk-margin-small uk-text-justify'>
                            <span className='text-primary'>Security Questions:</span> Answers to personalized security queries.
                        </p>
                    </div>
               </div>
            </div>
        </div>
        <div className="uk-section bg-primary">
            <div className="uk-container">
                <h1 className='text-primary uk-text-capitalize uk-text-center'>
                    Shipping information
                </h1>
                <div>
                    <h3 className='text-primary uk-text-capitalize uk-text-left uk-margin-small'>
                        Location :
                    </h3>
                    <p className='text-secondary uk-text-justify uk-margin-small'>
                        The place from which the product will be shipped.
                    </p>
                    <h3 className='text-primary uk-text-capitalize uk-text-left uk-margin-small'>
                        Destination Address :
                    </h3>
                    <p className='text-secondary uk-text-justify uk-margin-small'>
                        Where the product should be delivered.
                    </p>
                    <h3 className='text-primary uk-text-capitalize uk-text-left uk-margin-small'>
                        Liability :
                    </h3>
                    <p className='text-secondary uk-text-justify uk-margin-small'>
                        While we strive to use commercially acceptable means to protect your personal data, we cannot guarantee its absolute security. In the event of a data breach, we will notify you and any applicable regulator when we are legally required to do so.
                    </p>
                </div>
            </div>
        </div>
        <div className="uk-section">
            <div className="uk-container">
                <h1 className='text-primary uk-text-capitalize uk-text-center'>
                    Conditions for Data Disclosure
                </h1>
                <div>
                    <p className='text-secondary uk-text-justify uk-margin-small'>
                        This clause delineates the specific conditions under which the service provider may disclose personal information collected from users. The service provider commits to upholding the confidentiality of user data, except in the following situations:
                    </p>
                    <h3 className='text-primary uk-text-capitalize uk-text-left uk-margin-small'>
                        Legal Compliance :
                    </h3>
                    <p className='text-secondary uk-text-justify uk-margin-small'>
                        If required by law, such as through a subpoena or other legal process, the service provider may disclose user information to comply with the request.
                    </p>
                    <h3 className='text-primary uk-text-capitalize uk-text-left uk-margin-small'>
                        Service Operations :
                    </h3>
                    <p className='text-secondary uk-text-justify uk-margin-small'>
                        To facilitate the normal operation of services, certain information may be shared with third-party service providers or partners, but only to the extent necessary for the provision of said services.
                    </p> 
                    <h3 className='text-primary uk-text-capitalize uk-text-left uk-margin-small'>
                        Consent :
                    </h3>
                    <p className='text-secondary uk-text-justify uk-margin-small'>
                        If the user has given explicit consent for the sharing of their information for a specific purpose.
                    </p>
                    <h3 className='text-primary uk-text-capitalize uk-text-left uk-margin-small'>
                        Safety and Security :
                    </h3>
                    <p className='text-secondary uk-text-justify uk-margin-small'>
                        In cases where there is a reasonable belief that disclosing information is necessary to protect the safety, rights, or property of the service provider, the user, or the public.
                    </p>
                    <h3 className='text-primary uk-text-capitalize uk-text-left uk-margin-small'>
                        Business Transfers :
                    </h3>
                    <p className='text-secondary uk-text-justify uk-margin-small'>
                        In the event of a merger, acquisition, or sale of all or a portion of assets, user information may be transferred as part of the transaction.
                    </p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default privacy